import apiService from '../../../repositories/apiService';

export default {
    getRecruitmentDepthChartByLocation(state, payload) {
        return new Promise((resolve, reject) => {
            apiService.get(
                '/recruitment_depth_charts/recruitment_depth_chart_by_location/',
                {
                    params: {
                        location_id: payload.locationId,
                    },
                },
            )
                .then((response) => {
                    // eslint-disable-next-line no-console
                    state.commit('setRecruitmentDepthChart', response.data);
                    resolve(response);
                })
                .catch((error) => {
                    state.commit('setRecruitmentDepthChart', null);
                    state.commit('setError', error);
                    reject(error);
                });
        });
    }
};
